<template>
  <header id="header" class="mecanique">
    <div class="top_bar mobile_wpml_hidden mobile_contacts_hidden mobile_socials_hidden mobile_cart_hidden mobile_search_hidden">
      <div class="container">

        <div class="top_bar_info_wr" style="justify-content: right;align-items: center;">
          <div class="virement-button-box ml-3" style="order: 11;">
            <button class="btn button blue text-uppercase virement-button py-2" style="border:2px solid #fff;border-radius:6px;" @click="requestWire" v-if="monthlyQuoteCommissionBalances.available >= 300">
              <span class="vb-icon d-none">
                <svg
                  width="24" height="24" viewBox="0 0 50 50"
                  xmlns="http://www.w3.org/2000/svg" aria-label="Loading" role="img">
                  <circle
                    cx="25" cy="25" r="20"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="6"
                    stroke-linecap="round"
                    stroke-dasharray="90 150"
                    transform="rotate(-90 25 25)">
                    <animateTransform
                      attributeName="transform"
                      type="rotate"
                      from="0 25 25"
                      to="360 25 25"
                      dur="1s"
                      repeatCount="indefinite" />
                  </circle>
                </svg>
              </span>
              <span class="vb-text">Virement de mes commissions</span>
            </button>
          </div>
          <div class="top_bar_info_switcher" style="max-height: none;">
            <div class="active"> <i style='font-size:30px' class='fa fa-user-circle'></i>
              <span>
                            {{mechanicName}}                        </span>
            </div>
            <ul style="display: none;">
              <li v-if="$can('read', 'account_representative')">
                <a href="/my-account-representative">
                  Mon compte
                </a>
              </li>
              <li v-else>
                <a href="/my-account">
                  Mon compte
                </a>
              </li>
              <li v-if="$can('read', 'account_representative')">
                <a href="/my-documents">
                  Mes documents
                </a>
              </li>
              <li>
                <a href="#" @click="$root.logOut">
                  Déconnexion
                </a>
              </li>
            </ul>
          </div>
          <ul class="top_bar_info" id="top_bar_info_0" style="display: block;">
            <li>

            </li>
            <li>
              <i class="stm-clock6" style="font-size: 15px; color: #fde428;"></i>
              <span>
                            <center>Bienvenue {{mechanicGarage}} - {{mechanicCode}}</center>                     </span>
            </li>
            <li>

            </li>
          </ul>
          <div class="monthly-commissions" v-if="isClientMonthlyPayment">
            <div class="monthly-commissions-title">Commissions</div>
            <div class="monthly-commissions-inner"><span>Disponibles:</span><span>&nbsp;</span><span>{{monthlyQuoteCommissionBalances.available}} €</span></div>
            <div class="monthly-commissions-inner"><span>En Réserve:</span><span>&nbsp;</span><span>{{monthlyQuoteCommissionBalances.reserved}} €</span></div>
          </div>
        </div>
      </div>
      <div class="header-box">
        <div class="container">
          <div class="logo-box">
            <div class="logo logo-desktop">
              <a href="https://assur-garantiesmecaniques.fr/" target="_blank" style="margin: 5%;">
                <img src="https://assur-garantiesmecaniques.fr/wp-content/uploads/2020/03/Fichier-9-8.png" style="width: 300px;" alt="dynassurances">
              </a>
            </div>
            <div class="logo logo-mobile">
              <a href="https://assur-garantiesmecaniques.fr/" target="_blank" style="margin: 0px 0px 0px 0px;">
                <img src="https://assur-garantiesmecaniques.fr/wp-content/uploads/2020/03/logo_assur_garanties_mecaniques_blanc-8.png" style="width: 300px; height: px;" alt="dynassurances">
              </a>
            </div>
            <div class="menu-toggle">
              <button>&nbsp;</button>
            </div>
          </div>
          <div class="header-phone">
            <ul class="icon-list-items">
              <li class="icon-list-item">
                <a href="tel:%200148895757">
								<span class="icon-list-icon">
							<i aria-hidden="true" class="fa fa-phone-alt"></i>						</span>
                  <span class="icon-list-text"> 01 48 89 57 57</span>
                </a>
              </li>
            </ul>
          </div>
          <div class="nav-box affix-top">
            <ul id="menu-menu-principal" class="main_menu_nav">
              <li  class="menu-item-has-children">
                <a href="https://assur-garantiesmecaniques.fr/offres-professionnelles/" target="_blank">
                  Offres<br/> pros </a>
                <ul class="sub-menu">
                  <li ><a href="https://assur-garantiesmecaniques.fr/offres-professionnelles/" target="_blank">Solutions Assurances</a></li>
                  <li><a href="https://assur-garantiesmecaniques.fr/solutions-auto-assurance/" target="_blank">Solution Auto-Assurances</a></li>
                </ul>
              </li>
              <li>
                <a href="https://assur-garantiesmecaniques.fr/offres-particuliers/" target="_blank"><center>Offres<br/>  Particuliers</center></a>
              </li>
              <li>
                <a href="https://assur-garantiesmecaniques.fr/qui-sommes-nous/" target="_blank"><center>Qui sommes<br/>  nous</center></a>
              </li>
              <li>
                <a href="https://assur-garantiesmecaniques.fr/contact/" target="_blank">Contact</a>
              </li>
            </ul>
          </div>


        </div>
      </div>

    </div>
  </header>
</template>

<script>
    export default {
        name: "GarantiesMechanic",
        props: {
          mechanicName: {
            default: '',
            type: String
          },
          mechanicGarage: {
            default: '',
            type: String
          },
          mechanicCode: {
            default: '',
            type: String
          },
          monthlyQuoteCommissionBalances: {
            type: Object,
            default: () => ({ available: 0, reserved: 0 })
          }
        },
        computed: {
          isClientMonthlyPayment() {
            return this.$store.getters.isClientMonthlyPayment;
          }
        },
        methods: {
          requestWire() {
            this.$emit('requestWire');
          }
        }
    }
</script>

<style scoped>
.monthly-commissions {
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.monthly-commissions-inner {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Headers/GarantiesMechanic.vue